import { render, staticRenderFns } from "./ListesPanneau.vue?vue&type=template&id=2b2a0166"
import script from "./ListesPanneau.vue?vue&type=script&lang=js"
export * from "./ListesPanneau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports